import React, { useState } from "react";
import Buy from "./Buy";
import Sell from "./Sell";
import { Tabs, Tab } from "@mui/material";

const TradeWidget = (props) => {
  const [tab, setTab] = useState(0);
  const handleTabChange = (e, newValue) => {
    setTab(newValue);
  };
  const renderSwitch = (param) => {
    switch (param) {
      case 0:
      default:
        return <Buy {...props}/>;
      case 1:
        return <Sell {...props}/>;
    }
  };
  return (
    <>
      <Tabs 
        value={tab} 
        onChange={handleTabChange} 
        variant="fullWidth"
        className="mb-3 fancyTabs"
        >
        <Tab label="Buy" />
        <Tab label="Sell" />
      </Tabs>
      {renderSwitch(tab)}
    </>
  );
};

export default TradeWidget;
